import * as React from 'react';
import { useEffect } from 'react';
import TopSearchTable from "src/pages/ProductListing/TopSearchTable";
import ActiveFilter from "src/pages/ProductListing/ActiveFilter";
import Listing from "src/pages/ProductListing/Listing";
import ProductCompareMiniSlider from 'src/component/Product/BottomCompareProduct/ProductCompareMiniSlider';
import { useSelector } from "react-redux";
import $ from "jquery";
import System from "src/helper/system";
import { useSearchParams } from "react-router-dom";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

let c = System.getParams();

export default function ProductListingTabContent(props) {
    const list = useSelector((state) => state.entities.ProductListingAPICall.data)
    const [searchParams] = useSearchParams();

    useEffect(() => {
        async function fetchHere() {
            if (list !== undefined &&
                list.value !== undefined &&
                c.ComingFromUniversalSearch !== undefined &&
                c.ComingFromUniversalSearch === 'yes'
            ) {
                delete c.ComingFromUniversalSearch;
                history.pushState(null, null, '?' + $.param(c));
                internalSearchEvent();
            }
        }
        fetchHere()
    }, [list])


    //By Ramya Kannan [Internal search - Adobe script ]
    function internalSearchEvent() {
      let pageCount = searchParams.get("limit") ? searchParams.get("limit") : 20;
      let checkifPagination = Math.round(list['@odata.count']/ pageCount);
      let searchDetails = {
        searchTerm: c.search || "",
        count:list['@odata.count'],
        pageCount : checkifPagination,
        isPagination: (checkifPagination >= 2) ? 1 : 0
      };
      localStorage.setItem("adobeEventType", "internalSearchEvent");

      if (Object.keys(searchDetails).length) {
        HelperAdobeEvent.trackingAdobeEvent({ searchDetails });
      }
    }


    return (
        <div>
            <TopSearchTable
                {...props}
                openFilterBoxSettings={() => {
                    System.popup('FilterSelectionPopup')
                }} />
            <ActiveFilter
                {...props}
                openFilterBoxSettings={() => {
                    System.popup('FilterSelectionPopup')
                }} />
            <Listing {...props} />
            <ProductCompareMiniSlider {...props} />
        </div>
    );
}
